import Act, { ActCode } from '../../../../shared/domain/activity/act/model/Act';
import { actFormFields } from '../../../containers/ActForm/constants';
import { getStore } from '../../../reduxStore/configureStore';
import { codeIsInRole2 } from '../../../../shared/domain/activity/act/service/actCodeUtils';
import { selectSpecialty } from '../../../containers/User/selectors';
import { RamqSpecialistActCodeNatureType } from '../../../../shared/medyx-core/types/ramq';
import RAMQCodes, { TimedAttributeKey } from 'shared/ramq/RamqCodes';

export const role2PdtAndSurgeryExclusiveCodesValidation = (act: Act) => {
  const userSpecialty = selectSpecialty()(getStore().getState());

  const surgeryCodes: ActCode[] = [];
  const pdtCodes: ActCode[] = [];

  act.codes?.forEach((code) => {
    const ramqCode = RAMQCodes.get(code.code);
    if (!ramqCode || !RAMQCodes.isCodeEffectiveOn(ramqCode, act.date)) {
      return false;
    }

    if (
      ramqCode.natureType === RamqSpecialistActCodeNatureType.CHIRURGIE &&
      !RAMQCodes.getTimedAttribute<boolean>(ramqCode, TimedAttributeKey.isAddendum8, act.date)
    ) {
      surgeryCodes.push(code);
    }

    if (
      ramqCode.natureType === RamqSpecialistActCodeNatureType.PDT &&
      !RAMQCodes.getTimedAttribute<boolean>(ramqCode, TimedAttributeKey.isAddendum8, act.date)
    ) {
      pdtCodes.push(code);
    }
  });

  if (
    act.codes?.some((code) => codeIsInRole2(code, act, userSpecialty)) &&
    surgeryCodes.length > 0 &&
    pdtCodes.length > 0
  ) {
    return {
      [actFormFields.codes]: {
        _error:
          pdtCodes.length > 1
            ? `Les codes PDT ${pdtCodes
                .map((code) => code.code)
                .join(', ')} ne peuvent s’ajouter avec un code de chirurgie. SVP enlever et envoyer.`
            : `Le code PDT ${pdtCodes.map((code) => code.code)} ne peut s’ajouter avec un code de chirurgie. SVP enlever et envoyer.`
      }
    };
  }
};

export default role2PdtAndSurgeryExclusiveCodesValidation;
